import { CategoriaDescuento, ProductoCupon } from '../models/promociones.model';
import {
  CatalogCategoryDto,
  CatalogPresentationDto,
  CatalogProductDto,
} from './product-catalog.types';

function porNombre<T extends { nombre: string }>(a: T, b: T): number {
  return a.nombre.localeCompare(b.nombre, 'es');
}

export function productosDelCatalogo(
  productos: CatalogProductDto[],
  presentaciones: CatalogPresentationDto[],
): ProductoCupon[] {
  return productos
    .map((producto) => ({
      producto,
      activas: presentaciones.filter((p) => p.productId === producto.id && p.isActive !== false),
    }))
    .filter(({ activas }) => activas.length > 0)
    .map(({ producto, activas }) => ({
      id: String(producto.id),
      nombre: producto.name,
      presentacion: activas.map((p) => p.name).join(', '),
    }))
    .sort(porNombre);
}

export function categoriasDelCatalogo(
  categorias: CatalogCategoryDto[],
  productos: CatalogProductDto[],
): CategoriaDescuento[] {
  return categorias
    .filter((c) => c.isActive !== false)
    .map((c) => ({
      id: String(c.id),
      nombre: c.name,
      cantidadProductos: productos.filter((p) => p.productCategoryId === c.id).length,
    }))
    .sort(porNombre);
}
